import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static values = { maxFiles: Number };

    connect() {
        this.maxFiles = this.data.get('maxFileSize') !== undefined ? this.data.get('maxFileSize') : 5; // Default to 3 if not set
    }

    checkFileLimit(event) {
        const input = event.target;
        if (input.files.length > this.maxFiles) {
            alert(`You can only upload up to ${this.maxFiles} files.`);
            input.value = ""; // Reset input to prevent excessive uploads
        }
    }
}